export const shopInfosProps = () => ({
  shopName: {
    type: String,
    required: true
  },
  shopfirstSlotAvailable: {
    type: String,
    required: false,
    default: null
  },
  shopLastSlotAvailable: {
    type: String,
    required: false,
    default: null
  }
})

export const shopInfosEmits = () => ([
  "togglePlanningPopin"
])

export const useShopInfos = (props, context) => {
  const lastSlotAvailable = computed(() => {
    return props.shopLastSlotAvailable.toLowerCase()
  })

  const togglePlanningPopin = () => {
    context.emit("togglePlanningPopin");
  }

  return { lastSlotAvailable, togglePlanningPopin }
}